// 引入所有的common的api
import systemApiMap from '@/emc-system/service/api/index';
import commonApiMap from '@/emc-common/service/index';
import qlApiMap from '@/bysc-ql/service/api/index';
let allApiMap = {}; // 定义一个API接口总集
Object.assign(allApiMap, allApiMap, systemApiMap); // 合并system模块
Object.assign(allApiMap, allApiMap, commonApiMap); // 合并common模块
Object.assign(allApiMap, allApiMap, qlApiMap); // 获取ql接口
export default allApiMap;
